import { render, staticRenderFns } from "./SeasonComponent.vue?vue&type=template&id=db18c14c&"
import script from "./SeasonComponent.vue?vue&type=script&lang=ts&"
export * from "./SeasonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports